import { ReactElement } from 'react';

import { Box } from '@r-client/shared/ui/core';

import styles from './wysiwyg-styles.module.scss';

export interface IWysiwygStylesProps {
  children: ReactElement | ReactElement[];
}

export const WysiwygStyles = ({ children }: IWysiwygStylesProps) => {
  return <Box className={styles.container}>{children}</Box>;
};
